import { defineStore } from 'pinia'
export const useUserStore = defineStore('user', {
  id: 'useUserStore',
  state: () => ({
    message: '',
    user: {d: { vocabulary: { index: 0, iKnow: [] } } },
    users: [],
    accessToken: null,
    isLoggedIn: false,
    isAdmin: false,
    error: [],
  }),
  actions: {
    setAccessToken(token) {
      this.accessToken = token
    },
    async loginTheUser(oj) {
      console.log('%c in login  . (969339505)', 'color:lightblue;', oj)
      //  this.user = { name: 'natan' }

      // this will add the user token to the headers
      const re = await fetch("/api/98734jlqrlkuoaiser987q345h", this.postAuTh(oj))
        .then((re) => re.json())
      // .then((d) => {
      //   console.log('%c d  . (1730659832)', 'color:lightblue;', d.user)
      // })
      console.log('%c re  . (1730659832)', 'color:lightblue;', re)
      if (re.user != null) {
        this.user = re.user
        this.accessToken = re.access_token
        this.isLoggedIn = true
        this.isAdmin = re.user.role_id > 70
        localStorage.setItem('accessToken', re.access_token)
     //   localStorage.setItem('user', JSON.stringify(re.user))
        localStorage.setItem('isLoggedIn', true)
        if(this.isAdmin){
          localStorage.setItem('isAdmin', true)
        }
        // redirect to the home page
        this.redirectUserAfterLogin()
      }
       if (re.message != null) {
        this.message = re.message
      }
      if (re.error != null) {
        this.error = re.error
      }
    },
    initializeStore() {
      const isLoggedIn = localStorage.getItem('isLoggedIn')
      const isAdmin = localStorage.getItem('isAdmin')
      this.isAdmin = isAdmin === 'true'
      this.accessToken = localStorage.getItem('accessToken')
      this.isLoggedIn = isLoggedIn === 'true'
      
      // Load user from localStorage for immediate UI
     // const user = localStorage.getItem('user')
      const user = null
      this.user = user ? JSON.parse(user) : {}
      
      // If user is logged in, refresh user data from server
      if (this.isLoggedIn && this.accessToken) {
        this.refreshUserFromServer()
      }
    },
    updateUserData() {
      // update the user data on the server 
      console.log('%c update the user data on the server  . (1760717770)', 'color:lightblue;')
      fetch('/api/update-user-data', this.postAuTh(this.user.d))
        .then((re) => re.json())
        .then((d) => {
          console.log('%c user update d on server successfully   . (1760717770)', 'color:lightblue;', d)
        })
    },
    async refreshUserFromServer() {
      console.log('%c get the user from the server  . (1760717770)', 'color:lightblue;')
      
      try {
        const response = await fetch('/api/get-user', {
          headers: {
            'Authorization': `Bearer ${this.accessToken}`,
            'Content-Type': 'application/json'
          }
        })
        
        if (response.ok) {
          const userData = await response.json()
          // Update store and localStorage with fresh data
          this.user = userData.user
          // localStorage.setItem('user', JSON.stringify(userData.user))
          console.log('%c User data refreshed from server', 'color:green;')
        } else if (response.status === 401) {
          // Token expired, logout user
          this.logoutTheUser()
        }
      } catch (error) {
        console.log('%c Failed to refresh user data:', 'color:orange;', error)
        // Keep using localStorage data as fallback
      }
    },
    logoutTheUser() {
      console.log('%c in logout  . (1730659831)', 'color:lightblue;')
      this.isLoggedIn = false
      this.user = {}
      this.accessToken = null
      this.isAdmin = false
      localStorage.removeItem('accessToken')
      localStorage.removeItem('user')
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('isAdmin')
      
    },

    // Sync user data when important changes happen
    syncUserData(updatedUserData) {
      this.user = { ...this.user, ...updatedUserData }
      localStorage.setItem('user', JSON.stringify(this.user))
    },
    async register(oj) {
      console.log('%c in register  . (1730359837)', 'color:lightblue;', oj)
      this.message = '' // Clear previous messages
      this.error = []
      
      try {
        const response = await fetch('/api/register', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(oj),
        })
        
        const data = await response.json()
        console.log('%c register response  . (1730359837)', 'color:lightblue;', data)
        console.log('%c register response  . (1730359837)', 'color:lightblue;', data)
        console.log('%c register response  . (1730359837)', 'color:lightblue;', data)
        console.log('%c register response  . (1730359837)', 'color:lightblue;', data)
        
        if (response.ok && data.user) {
          console.log(' response.ok  . (1760362154)', 'color:lightblue;')
          
          // Registration successful
          this.user = data.user
          this.accessToken = data.access_token
          this.isLoggedIn = true
          this.isAdmin = data.user.role_id > 70
          localStorage.setItem('accessToken', data.access_token)
          localStorage.setItem('user', JSON.stringify(data.user))
          localStorage.setItem('isLoggedIn', true)
          if(this.isAdmin){
            localStorage.setItem('isAdmin', true)
          }
          this.redirectUserAfterLogin()
       } else {
          // Registration failed
          if (data.message) {
            this.message = data.message
          }
          if (data.error) {
            this.error = data.error
          }
          if (data.errors) {
            // Handle Laravel validation errors
            const errorMessages = Object.values(data.errors).flat()
            this.message = errorMessages.join(', ')
          }
        }
        
        return data
      } catch (error) {
        console.error('Registration error:', error)
        this.message = 'Network error occurred during registration'
        throw error
      }
    },
    redirectUserAfterLogin() {
           // get the intended action before redirecting
           const intendedAction = localStorage.getItem('redirectAfterLogin')
           if (intendedAction) {
             // Clear the intended action after using it
             localStorage.removeItem('redirectAfterLogin')
             // Redirect based on the intended action
             window.location.href = intendedAction
           } else {
             window.location.href = '/'
           }
    },
    postAuTh(oj, withFile = false) {
      console.log('%c in postAuth - withFile . (1732875503) ', 'color:lightgreen;', withFile)

      // this will add the user token to the headers
      let re = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST, GET, OPTIONS',
          // ,
             "Authorization": 'Bearer ' + this.accessToken
        },
        body: JSON.stringify(oj)
      }
      if (withFile) {
        // no need for content type - it will be set by the browser
        re = { method: "POST", headers: { "Authorization": 'Bearer ' + this.accessToken }, body: oj }
      }
      console.log('%c return heders  . (1732875328) ', 'color:lightgreen;', re)
      return re
    },
    getAuTh() {
      // this will add the user token to the headers
      var myHeaders = new Headers()
   //   myHeaders.append("access-control-allow-headers", 'Content-Type, Authorization')
      myHeaders.append("Authorization", 'Bearer ' + this.accessToken)
      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      }
      return requestOptions
    },


    getTheUser() {
      // we need to check if the user is connected
      // if not we will not do anything
      // if the user is connected we will get the user data
      if (this.returnUserApiCredentials() == false) {
        console.log('%c no user connected  . (1733306591)', 'color:lightblue;')
        return false
      }

      // this will add the user token to the headers
      fetch("/api/v1/en/get-user", this.getAuTh())
        .then((re) => re.json())
        .then((d) => {
          console.log('%c re  . (1730659817)', 'color:lightblue;', d.user)
          this.user = d.user
        })
    },
    async fetchUsers(searchStr) {
      console.log('%c store fetchEvent run  . (1678905209) ', 'color:lightgreen;')
      try {
        // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
        // resources/views/layouts/app.blade.php
        let url = `/api/v1/en/get_users`
        let user_token = this.getUserToken()
        url = url + `?user_token=${user_token}`
        url = url + `&search=${searchStr}`
        console.log('%c url  . (2369989611) ', 'color:lightgreen;', url)
        let re = await fetch(url)
          .then((response) => response.json())
        console.log('%c in userStore  . (2369989611) ', 'color:lightgreen;', re)
        this.users = re.users

      } catch (error) {
        console.log('%c error  . (2369989611)', 'color:lightgreen;', error)
        this.users = []
      }
    },
    getUserToken() {
      let user_token = false
      if (document.querySelector('meta[name="user_token"]')) {
        user_token = document.querySelector('meta[name="user_token"]').content
      }
      return user_token
    }
  }
})


